import { render, staticRenderFns } from "./host-common-banner.vue?vue&type=template&id=ede76f64&scoped=true&"
import script from "./host-common-banner.vue?vue&type=script&lang=js&"
export * from "./host-common-banner.vue?vue&type=script&lang=js&"
import style0 from "./host-common-banner.vue?vue&type=style&index=0&id=ede76f64&lang=scss&scoped=true&"
import style1 from "./host-common-banner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede76f64",
  null
  
)

export default component.exports